// !!!!! IMPORTANT !!!!!
// IF ADDING NEW TOOL: ensure it also gets added to productCode.ts and the appropriate subscriptions in subscriptionType.ts
export var ToolType;
(function (ToolType) {
    // Add Data
    ToolType["FILE"] = "file";
    ToolType["CLOUD"] = "cloud";
    ToolType["DEMAND_FORECAST"] = "demand_forecast";
    ToolType["SAMPLE_CUSTOMERS"] = "sample_customers";
    ToolType["PIPE"] = "pipe";
    ToolType["MULTI_PORT_PIPE"] = "multi_port_pipe";
    // API = 'api',
    // Transform
    ToolType["ADAPT"] = "adapt";
    ToolType["AGGREGATE"] = "aggregate";
    ToolType["AGGREGATEV2"] = "aggregate_v2";
    ToolType["AMORTIZATION"] = "amortization";
    ToolType["BINNING"] = "binning";
    ToolType["CATEGORY_ENCODER"] = "category_encoder";
    ToolType["CASE"] = "case";
    ToolType["CHANGE_CASE"] = "change_case";
    ToolType["CHANGE_TYPE"] = "change_type";
    ToolType["CLEAN_CHARACTER"] = "clean_character";
    ToolType["COMBINATION_MATCHER"] = "combination_matcher";
    ToolType["CONDITIONAL"] = "conditional";
    ToolType["CONFUSION_MATRIX"] = "confusion_matrix";
    ToolType["DATE_ADD"] = "date_add";
    ToolType["DATE_DIFF"] = "date_diff";
    ToolType["DATE_PART"] = "date_part";
    ToolType["DATE_AGGREGATE"] = "date_aggregate";
    ToolType["DATE_FORMAT"] = "date_format";
    // DATE = 'date',
    ToolType["DISTINCT"] = "distinct";
    ToolType["DROP"] = "drop";
    ToolType["EXPORT"] = "export";
    ToolType["EXTRACT"] = "extract";
    ToolType["FILL"] = "fill";
    ToolType["FILTER"] = "filter";
    ToolType["FORMULA"] = "formula";
    ToolType["MULTI_FORMULA"] = "multi_formula";
    ToolType["FUZZY_MATCHER"] = "fuzzy_matcher";
    ToolType["JOIN"] = "join";
    ToolType["JOINV2"] = "join_v2";
    ToolType["LAG"] = "lag";
    ToolType["LIMIT"] = "limit";
    ToolType["MERGE_COLUMNS"] = "merge_columns";
    ToolType["MIN_MAX_SCALER"] = "min_max_scaler";
    ToolType["MONTE_CARLO"] = "monte_carlo";
    ToolType["MOST_COMMON"] = "most_common";
    ToolType["ONE_HOT_ENCODER"] = "one_hot_encoder";
    ToolType["OVERSAMPLE"] = "oversample";
    ToolType["PREDICT_GENDER"] = "predict_gender";
    ToolType["QUANTILE"] = "quantile";
    // PIVOT = 'pivot',
    ToolType["RANDOM_NUMBER_GENERATOR"] = "random_number_generator";
    ToolType["RANK"] = "rank";
    ToolType["RECORD_ID"] = "record_id";
    ToolType["REMOVE_OUTLIERS"] = "remove_outliers";
    ToolType["REMOVE_EMPTY"] = "remove_empty";
    ToolType["RENAME"] = "rename";
    ToolType["REORDER"] = "reorder";
    ToolType["REPEAT"] = "repeat";
    ToolType["REPLACE"] = "replace";
    ToolType["MULTI_REPLACE"] = "multi_replace";
    ToolType["RESHAPE"] = "reshape";
    ToolType["RESHAPEV2"] = "reshape_v2";
    ToolType["RUNNING_AVERAGE"] = "running_average";
    ToolType["RUNNING_TOTAL"] = "running_total";
    ToolType["SAMPLE"] = "sample";
    ToolType["SEGMENTATION"] = "segmentation";
    ToolType["SELECT"] = "select";
    ToolType["SELECT_WORD"] = "select_word";
    ToolType["SMART_MATCHER"] = "smart_matcher";
    ToolType["SNAPSHOT"] = "snapshot";
    ToolType["SORT"] = "sort";
    ToolType["SPLIT"] = "split";
    ToolType["STANDARD_SCALER"] = "standard_scaler";
    // TEXT = 'text',
    ToolType["TEXT_GRADE_LEVEL"] = "text_grade_level";
    ToolType["TEXT_BETWEEN"] = "text_between";
    ToolType["TEXT_LENGTH"] = "text_length";
    ToolType["TEXT_PART"] = "text_part";
    ToolType["TEXT_SENTIMENT"] = "text_sentiment";
    ToolType["TRIM"] = "trim";
    ToolType["TRIM_TAGS"] = "trim_tags";
    ToolType["UNDERSAMPLE"] = "undersample";
    ToolType["UNION"] = "union";
    ToolType["MULTI_UNION"] = "multi_union";
    ToolType["WEIGHTED_AVERAGE"] = "weighted_average";
    // Classification
    ToolType["CLASSIFIER"] = "classifier";
    ToolType["CAT_BOOST_CLASSIFIER"] = "cat_boost_classifier";
    ToolType["DECISION_TREE_TRAIN"] = "decision_tree_train";
    ToolType["GBT_TRAIN"] = "gbt_train";
    ToolType["K_NEIGHBORS_CLASSIFIER"] = "k_neighbors_classifier";
    ToolType["LGBM_CLASSIFIER"] = "lgbm_classifier";
    ToolType["LOGISTIC_REGRESSION_TRAIN"] = "logistic_regression_train";
    ToolType["NAIVE_BAYES_TRAIN"] = "naive_bayes_train";
    ToolType["RANDOM_FOREST_TRAIN"] = "random_forest_train";
    ToolType["SVM_TRAIN"] = "svm_train";
    ToolType["XGB_CLASSIFIER"] = "xgb_classifier";
    // Regression
    ToolType["REGRESSOR"] = "regressor";
    ToolType["DECISION_TREE_REGRESSOR"] = "decision_tree_regressor";
    ToolType["GBT_REGRESSOR"] = "gbt_regressor";
    ToolType["K_NEIGHBORS_REGRESSOR"] = "k_neighbors_regressor";
    ToolType["LGBM_REGRESSOR"] = "lgbm_regressor";
    ToolType["LINEAR_REGRESSION_TRAIN"] = "linear_regression_train";
    ToolType["MLP_REGRESSOR"] = "mlp_regressor";
    ToolType["RANDOM_FOREST_REGRESSOR"] = "random_forest_regressor";
    ToolType["XGB_REGRESSOR"] = "xgb_regressor";
    ToolType["CAT_BOOST_REGRESSOR"] = "cat_boost_regressor";
    // Forecast
    ToolType["FORECAST"] = "forecast";
    ToolType["ARIMA_FORECAST"] = "arima_forecast";
    ToolType["AUTO_REGRESSIVE_FORECAST"] = "auto_regressive_forecast";
    ToolType["EXP_SMOOTHING_FORECAST"] = "exp_smoothing_forecast";
    ToolType["LINEAR_REGRESSION_FORECAST"] = "linear_regression_forecast";
    ToolType["MOVING_AVERAGE_FORECAST"] = "moving_average_forecast";
    ToolType["PROPHET_FORECAST"] = "prophet_forecast";
    ToolType["SEASONAL_ARIMA_FORECAST"] = "seasonal_arima_forecast";
    ToolType["SIMPLE_EXP_SMOOTHING_FORECAST"] = "simple_exp_smoothing_forecast";
    ToolType["VECTOR_AUTO_REGRESSIVE_FORECAST"] = "vector_auto_regressive_forecast";
    ToolType["WEIGHTED_MOVING_AVERAGE_FORECAST"] = "weighted_moving_average_forecast";
    // Text
    ToolType["CNN_TEXT_CLASSIFIER"] = "cnn_text_classifier";
    ToolType["BOW_TEXT_CLASSIFIER"] = "bow_text_classifier";
    ToolType["ENSEMBLE_TEXT_CLASSIFIER"] = "ensemble_text_classifier";
    ToolType["TEXT_CLASSIFIER"] = "text_classifier";
    ToolType["WORD_FREQUENCY"] = "word_frequency";
    // Outlier
    ToolType["OUTLIER"] = "outlier";
    ToolType["ABOD_OUTLIER"] = "abod_outlier";
    ToolType["CBLOF_OUTLIER"] = "cblof_outlier";
    ToolType["COF_OUTLIER"] = "cof_outlier";
    ToolType["HBOS_OUTLIER"] = "hbos_outlier";
    ToolType["IQR_OUTLIER"] = "iqr_outlier";
    ToolType["ISOLATION_FOREST_OUTLIER"] = "isolation_forest_outlier";
    ToolType["K_NEIGHBORS_OUTLIER"] = "k_neighbors_outlier";
    ToolType["MULTI_OBJECTIVE_GAAL_OUTLIER"] = "multi_objective_gaal_outlier";
    ToolType["ONE_CLASS_SVM_OUTLIER"] = "one_class_svm_outlier";
    ToolType["PCA_OUTLIER"] = "pca_outlier";
    ToolType["SINGLE_OBJECTIVE_GAAL_OUTLIER"] = "single_objective_gaal_outlier";
    ToolType["SUBSPACE_OUTLIER"] = "subspace_outlier";
    ToolType["Z_SCORE_OUTLIER"] = "z_score_outlier";
    // Assignment Optimization
    ToolType["ASSIGNMENT_OPTIMIZATION"] = "assignment_optimization";
    // High Level
    ToolType["PREDICTOR"] = "predictor";
    // External Data
    ToolType["US_INCOME"] = "us_income";
    ToolType["US_POPULATION"] = "us_population";
    ToolType["WEATHER"] = "weather";
    // LINEAR = 'linear',
    // STEPWISE = 'stepwise',
    // Layout
    // COMMENT = 'comment',
    // CONTAINER = 'container',
    ToolType["HIERARCHY"] = "hierarchy";
    ToolType["HIERARCHYV2"] = "hierarchy_v2";
    ToolType["HIERARCHY_VALIDATOR"] = "hierarchy_validator";
    ToolType["HIERARCHY_VALIDATORV2"] = "hierarchy_validator_v2";
    ToolType["LOOKUP"] = "lookup";
    ToolType["SPLIT_COLUMNS"] = "split_columns";
    // SPM Tools
    ToolType["PERIOD_MAPPER"] = "period_mapper";
    ToolType["RULE_MAPPER"] = "rule_mapper";
    ToolType["RULE_MAPPERV2"] = "rule_mapper_v2";
    // Incentives Tools
    ToolType["INCENTIVES_EXPORT"] = "incentives_export";
    ToolType["INCENTIVES_IMPORT"] = "incentives_import";
    ToolType["INCENTIVES_TABLE"] = "incentives_table";
    ToolType["INCENTIVES_PERIOD"] = "incentives_period";
    ToolType["USER_DEFINED_CALC"] = "user_defined_calc";
    ToolType["SORT_CALC"] = "sort_calc";
    ToolType["TIME_SHIFT_CALC"] = "time_shift_calc";
    ToolType["CATEGORY_CALC"] = "category_calc";
    ToolType["TRUE_UP"] = "true_up";
    ToolType["PERIOD_ADD"] = "period_add";
    ToolType["PERIOD_DIFF"] = "period_diff";
    ToolType["EXPAND_PICKLIST"] = "expand_picklist";
    ToolType["PERIOD_ACCUMULATION"] = "period_accumulation";
    // Reusable Logic
    ToolType["REUSABLE_LOGIC_INPUT"] = "reusable_logic_input";
    ToolType["REUSABLE_LOGIC_OUTPUT"] = "reusable_logic_output";
    ToolType["REUSABLE_LOGIC"] = "reusable_logic";
    ToolType["NONE"] = "none"; // Don't use this, it is only used for factory
})(ToolType || (ToolType = {}));
export const ClassifierToolTypes = [
    ToolType.CLASSIFIER,
    ToolType.CAT_BOOST_CLASSIFIER,
    ToolType.DECISION_TREE_TRAIN,
    ToolType.GBT_TRAIN,
    ToolType.K_NEIGHBORS_CLASSIFIER,
    ToolType.LGBM_CLASSIFIER,
    ToolType.LOGISTIC_REGRESSION_TRAIN,
    ToolType.NAIVE_BAYES_TRAIN,
    ToolType.RANDOM_FOREST_TRAIN,
    ToolType.SVM_TRAIN,
    ToolType.XGB_CLASSIFIER
];
export const RegressionToolTypes = [
    ToolType.REGRESSOR,
    ToolType.CAT_BOOST_REGRESSOR,
    ToolType.DECISION_TREE_REGRESSOR,
    ToolType.GBT_REGRESSOR,
    ToolType.K_NEIGHBORS_REGRESSOR,
    ToolType.LGBM_REGRESSOR,
    ToolType.LINEAR_REGRESSION_TRAIN,
    ToolType.MLP_REGRESSOR,
    ToolType.RANDOM_FOREST_REGRESSOR,
    ToolType.XGB_REGRESSOR
];
export const TextClassifierToolTypes = [
    ToolType.TEXT_CLASSIFIER,
    ToolType.CNN_TEXT_CLASSIFIER,
    ToolType.BOW_TEXT_CLASSIFIER,
    ToolType.ENSEMBLE_TEXT_CLASSIFIER
];
export const ForecastToolTypes = [
    ToolType.FORECAST,
    ToolType.ARIMA_FORECAST,
    ToolType.EXP_SMOOTHING_FORECAST,
    ToolType.LINEAR_REGRESSION_FORECAST,
    ToolType.AUTO_REGRESSIVE_FORECAST,
    ToolType.MOVING_AVERAGE_FORECAST,
    ToolType.PROPHET_FORECAST,
    ToolType.SEASONAL_ARIMA_FORECAST,
    ToolType.SIMPLE_EXP_SMOOTHING_FORECAST,
    ToolType.VECTOR_AUTO_REGRESSIVE_FORECAST,
    ToolType.WEIGHTED_MOVING_AVERAGE_FORECAST
];
export const TrainToolTypes = [...ClassifierToolTypes, ...RegressionToolTypes, ToolType.PREDICTOR];
export const FilterToolTypes = [ToolType.FILTER, ToolType.CONDITIONAL];
export const ProbaOutlierToolTypes = [
    ToolType.ABOD_OUTLIER,
    ToolType.CBLOF_OUTLIER,
    ToolType.COF_OUTLIER,
    ToolType.HBOS_OUTLIER,
    ToolType.ISOLATION_FOREST_OUTLIER,
    ToolType.K_NEIGHBORS_OUTLIER,
    ToolType.MULTI_OBJECTIVE_GAAL_OUTLIER,
    ToolType.ONE_CLASS_SVM_OUTLIER,
    ToolType.PCA_OUTLIER,
    ToolType.SINGLE_OBJECTIVE_GAAL_OUTLIER,
    ToolType.SUBSPACE_OUTLIER
];
export const MachineLearningToolTypes = [
    ...TrainToolTypes,
    ...TextClassifierToolTypes,
    ...ForecastToolTypes,
    ...ProbaOutlierToolTypes,
    ToolType.ASSIGNMENT_OPTIMIZATION,
    ToolType.MONTE_CARLO
];
export const ToolsWithDependees = [ToolType.PIPE, ToolType.MULTI_PORT_PIPE, ToolType.INCENTIVES_IMPORT];
export const PipeToolTypes = [ToolType.PIPE, ToolType.MULTI_PORT_PIPE];
export const MultiInputToolTypes = [
    ToolType.MULTI_PORT_PIPE,
    ToolType.USER_DEFINED_CALC,
    ToolType.SORT_CALC,
    ToolType.CATEGORY_CALC,
    ToolType.MULTI_UNION,
    ToolType.REUSABLE_LOGIC,
    ToolType.EXPAND_PICKLIST
];
export const MultiInputToolTypesNoConfig = [
    ToolType.USER_DEFINED_CALC,
    ToolType.SORT_CALC,
    ToolType.CATEGORY_CALC,
    ToolType.MULTI_UNION
];
export const MultiOutputToolTypes = [ToolType.MULTI_PORT_PIPE, ToolType.REUSABLE_LOGIC];
export const IncentivesToolTypes = [
    ToolType.INCENTIVES_EXPORT,
    ToolType.INCENTIVES_IMPORT,
    ToolType.INCENTIVES_TABLE,
    ToolType.USER_DEFINED_CALC,
    ToolType.SORT_CALC,
    ToolType.TIME_SHIFT_CALC,
    ToolType.CATEGORY_CALC,
    ToolType.INCENTIVES_PERIOD,
    ToolType.TRUE_UP,
    ToolType.PERIOD_ADD,
    ToolType.PERIOD_DIFF,
    ToolType.EXPAND_PICKLIST,
    ToolType.PERIOD_ACCUMULATION
];
export const IncentivesCalendarsToolTypes = [ToolType.INCENTIVES_PERIOD, ToolType.SORT, ToolType.RUNNING_TOTAL];
export const FileToolTypes = [ToolType.FILE, ToolType.INCENTIVES_IMPORT, ToolType.INCENTIVES_TABLE];
export const SupportNodeCalcStatusToolTypes = [ToolType.EXPORT, ToolType.INCENTIVES_EXPORT];
export const ReusableLogicToolTypes = [ToolType.REUSABLE_LOGIC_INPUT, ToolType.REUSABLE_LOGIC_OUTPUT];
// Tools that are not allowed to be used within a Reusable Logic
export const ReusableLogicForbiddenToolTypes = [
    ToolType.FILE,
    ToolType.EXPORT,
    ToolType.MULTI_PORT_PIPE,
    ToolType.PIPE,
    ToolType.INCENTIVES_IMPORT,
    ToolType.INCENTIVES_EXPORT,
    ToolType.INCENTIVES_TABLE
];
// incentives composer only
export const LineageVertexToolTypes = [ToolType.INCENTIVES_EXPORT, ToolType.INCENTIVES_TABLE];
// Tools that are outdated and is replaced by another tool. The key is the outdated tool and the value is the tool that replaces it.
export const OutdatedTools = new Map([
    [ToolType.UNION, ToolType.MULTI_UNION],
    [ToolType.HIERARCHY, ToolType.HIERARCHYV2],
    [ToolType.HIERARCHY_VALIDATOR, ToolType.HIERARCHY_VALIDATORV2],
    [ToolType.AGGREGATE, ToolType.AGGREGATEV2],
    [ToolType.RESHAPE, ToolType.RESHAPEV2],
    [ToolType.JOIN, ToolType.JOINV2],
    [ToolType.RULE_MAPPER, ToolType.RULE_MAPPERV2]
]);
export const UnionToolTypes = [ToolType.UNION, ToolType.MULTI_UNION];
export const JoinToolTypes = [ToolType.JOIN, ToolType.JOINV2];
export const TwoOrMoreInputToolTypes = [ToolType.MULTI_UNION];
export const UnitTestInputToolTypes = [
    ToolType.FILE,
    ToolType.INCENTIVES_TABLE,
    ToolType.INCENTIVES_IMPORT,
    ToolType.REUSABLE_LOGIC_INPUT
];
export const UnitTestOutputToolTypes = [ToolType.EXPORT, ToolType.INCENTIVES_EXPORT, ToolType.REUSABLE_LOGIC_OUTPUT];
export const RuleMapperToolTypes = [ToolType.RULE_MAPPER, ToolType.RULE_MAPPERV2];
//# sourceMappingURL=toolType.js.map